export default __webpack_public_path__ + "static/media/logo-landtrust-plus-v-2-1.56948974.webp";